import type { FC, ReactNode } from 'react';

import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';

export const SnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <NotistackSnackbarProvider
      dense
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      className="!min-w-0"
      classes={{ root: '!min-w-0' }}
      maxSnack={3}
    >
      {children}
    </NotistackSnackbarProvider>
  );
};
